module.exports = [
  { type: 'inv-auth', name: 'Invoice Authorisation', action: 'inv auth' }
]
